module.exports = __webpack_public_path__ + "static/media/Penelope_colica.4002490d.png";